$(document).ready(function(){
  $(document).on('click','.ccm-mobile-menu .top-menu .menu-item>a',function(e){
    e.preventDefault()
    $(this).closest('.menu-item').siblings('.active').removeClass('active');
    $('.slide-nav__item[id="'+$(this).attr('data-tab-id')+'"]').siblings('.active').removeClass('active');
    $('.slide-nav__item[id="'+$(this).attr('data-tab-id')+'"]').addClass('active');
    $(this).closest('.menu-item').addClass('active');
  });
  $(document).on('click','.ccm-mobile-menu .sub-menu-title a',function(e){
    e.preventDefault()
    $(this).closest('.slide-nav__item').find('.slide-nav__dropdown').slideToggle();
    $(this).closest('.slide-nav__item').toggleClass('active');
  });
  $(document).on('click','.ccm-mobile-menu .close',function(e){
    e.preventDefault()
    $('.header-layout .site-nav__icons .site-nav__link.js-toggle-slide-nav.is-active').trigger('click');
  });

  $(document).on('click','.btn-quote',function (e) {
      e.preventDefault();
      $('.quote-form').removeClass('hide');
       setTimeout(function(){
         $('html, body').animate({scrollTop:$('#quote-form').position().top}, 'slow');
       }, 500);  
  });
});


  // Function to update the menu title based on screen width
  // function updateMenuTitle() {
  //   const screenWidth = $(window).width(); // Get the current screen width

  //   // Check if the screen width is less than a mobile breakpoint (e.g., 768 pixels)
  //   if (screenWidth < 768) {
  //     // Change the menu title for mobile
  //     $("ul#SlideNav li#hire-sydney_3 ul.slide-nav__dropdown li:nth-child(6) .sub-menu-title.default a").text("EVENT HIRE PACKAGES");
  //   } else {
  //     // Restore the default menu title for larger screens
  //     $("ul#SlideNav li#hire-sydney_3 ul.slide-nav__dropdown li:nth-child(6) .sub-menu-title.default a").text("HIRE PACKAGES");
  //   }
  // }


   $(document).ready(function() {
      // Get the textarea element using jQuery
      const $textarea = $(".text_user_input");
      const $p = $(".sizes_limit_text");


      // Add an event listener to the textarea for input changes
      $textarea.on("input", function() {
        // Get the current content of the textarea
        const content = $textarea.val();

        // Check if the content contains four or more consecutive characters without spaces
        if (/[^ ]{3,}/.test(content)) {
          // Add a class to change the teqxt color
          $p.addClass("valid");
          
        } else {
          // Remove the class if the condition is not met
          $p.removeClass("valid");
        }
      });
    });


    $(document).ready(function() {
  // Get the textarea and paragraph elements using jQuery
  const $textarea = $(".text_user_input");
  const $p = $(".sizes_limit_text");

  // Add an event listener to the textarea for input changes
  $textarea.on("input", function() {
    // Get the current content of the textarea
    const content = $textarea.val();

    // Check the length of the content and add or remove a class from the paragraph accordingly
    if (content.length >= 1 && content.length <= 2) {
      $p.addClass("valid");
    } else {
      $p.removeClass("valid");
    }
  });

  // Initially check the content length and add or remove the class
  $textarea.trigger("input");
});

document.addEventListener("DOMContentLoaded", function() {

  var productOptionDivs = document.querySelectorAll('.product-option');

    productOptionDivs.forEach(function(productOptionDiv) {
        var dtElements = productOptionDiv.querySelectorAll('dt');

        dtElements.forEach(function(dtElement) {
            if (dtElement.innerHTML.trim() === 'Background Image:') {
                productOptionDiv.style.display = 'none';
            }
            if (dtElement.innerHTML.trim() === 'Preview:') {
              productOptionDiv.style.display = 'none';
            }
            if (dtElement.innerHTML.trim() === 'Choose Font:') {
              productOptionDiv.style.display = 'none';
            }
            if (dtElement.innerHTML.trim() === 'Choose A Color:') {
              productOptionDiv.style.display = 'none';
            }
        });
    });

    var cartItemNames = document.querySelectorAll('.cart-item__name');

      cartItemNames.forEach(function(cartItemName) {
          if (cartItemName.textContent.trim() === 'Your Custom Neon') {
              var parentDiv = cartItemName.closest('.cart-item'); // Assuming the parent div has class 'cart-item'
              var productOptionDiv = parentDiv.querySelector('p.product-option');
              
              if (productOptionDiv) {
                productOptionDiv.innerHTML = "* The size refers to the neon width at its widest point. The height will vary based on the font used, and will stay within the font’s original design ratio.";
              }
          }
      });

  setTimeout(function(){
    var productOptionDivs = document.querySelectorAll('.product-option');

    productOptionDivs.forEach(function(productOptionDiv) {
        var dtElements = productOptionDiv.querySelectorAll('dt');

        dtElements.forEach(function(dtElement) {
            if (dtElement.innerHTML.trim() === 'Background Image:') {
                productOptionDiv.style.display = 'none';
            }
            if (dtElement.innerHTML.trim() === 'Preview:') {
              productOptionDiv.style.display = 'none';
            }
            if (dtElement.innerHTML.trim() === 'Choose Font:') {
              productOptionDiv.style.display = 'none';
            }
            if (dtElement.innerHTML.trim() === 'Choose A Color:') {
              productOptionDiv.style.display = 'none';
            }
        });
    });

    var cartItemNames = document.querySelectorAll('.cart-item__name');

      cartItemNames.forEach(function(cartItemName) {
          if (cartItemName.textContent.trim() === 'Your Custom Neon') {
              var parentDiv = cartItemName.closest('.cart-item'); // Assuming the parent div has class 'cart-item'
              var productOptionDiv = parentDiv.querySelector('p.product-option');
              
              if (productOptionDiv) {
                productOptionDiv.innerHTML = "* The size refers to the neon width at its widest point. The height will vary based on the font used, and will stay within the font’s original design ratio.";
              }
          }
      });
  },1000);

  $('cart-remove-button .button').click(function() {
    setTimeout(function(){
      var productOptionDivs = document.querySelectorAll('.product-option');
  
      productOptionDivs.forEach(function(productOptionDiv) {
          var dtElements = productOptionDiv.querySelectorAll('dt');
  
          dtElements.forEach(function(dtElement) {
              if (dtElement.innerHTML.trim() === 'Background Image:') {
                  productOptionDiv.style.display = 'none';
              }
              if (dtElement.innerHTML.trim() === 'Preview:') {
                productOptionDiv.style.display = 'none';
              }
              if (dtElement.innerHTML.trim() === 'Choose Font:') {
                productOptionDiv.style.display = 'none';
              }
              if (dtElement.innerHTML.trim() === 'Choose A Color:') {
                productOptionDiv.style.display = 'none';
              }
          });
      });

      var cartItemNames = document.querySelectorAll('.cart-item__name');

      cartItemNames.forEach(function(cartItemName) {
          if (cartItemName.textContent.trim() === 'Your Custom Neon') {
              var parentDiv = cartItemName.closest('.cart-item'); // Assuming the parent div has class 'cart-item'
              var productOptionDiv = parentDiv.querySelector('p.product-option');
              
              if (productOptionDiv) {
                productOptionDiv.innerHTML = "* The size refers to the neon width at its widest point. The height will vary based on the font used, and will stay within the font’s original design ratio.";
              }
          }
      });
    },2000);
  });
  

  setTimeout(function(){
    var cartRows = document.querySelectorAll('table.cart-items tbody tr');

      cartRows.forEach(function(cartRow) {
          var nameTd = cartRow.querySelector('.cart-item__name');
          var imgTd = cartRow.querySelector('.cart-item__image');
          var linkk = cartRow.querySelector('.cart-item__link');

          if (nameTd && nameTd.innerHTML == 'Your Custom Neon') {
              nameTd.removeAttribute('href');

              if (imgTd.parentElement.querySelector('a')) {
                  imgTd.parentElement.querySelector('a').removeAttribute('href');
              }
              if (linkk) {
                linkk.removeAttribute('href');
            }
          }        
          
      });
  },1000);
});























      document.addEventListener("DOMContentLoaded", function () {
    const variantSelect = document.querySelector("variant-selects select");
    const priceElement = document.querySelector("[data-product-price]"); // Make sure the correct selector is used

    function updatePrice() {
        if (!variantSelect || !priceElement) return;

        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        const selectedVariantID = selectedOption.value; // Get selected variant ID

        fetch(`/products/${Shopify.handle}.js`)
            .then(response => response.json())
            .then(data => {
                const selectedVariant = data.variants.find(variant => variant.id == selectedVariantID);
                if (selectedVariant) {
                    priceElement.innerText = `₹${(selectedVariant.price / 100).toFixed(2)}`;
                }
            })
            .catch(error => console.error("Error fetching variant price:", error));
    }

    if (variantSelect) {
        variantSelect.addEventListener("change", updatePrice);
        updatePrice(); // Run initially to set the correct price
    }
});
  
